import { Link, Outlet } from "react-router-dom"
import { useAppSelector } from "../../store/store"
import Header from "../../components/Header"

const AwardsTemplate = () => {
    const player = useAppSelector(state => state.player)

    return (
        <div className="flex flex-col">
            <Header className="flex flex-col gap-5 bg-[#46464c]">
                <p className="text-white font-extrabold uppercase text-4xl">Premios</p>
                {player.admin && <Link className="text-white font-semibold" to="/awards/create">Administrar</Link>}
            </Header>
            <Outlet />
        </div>
    )
}

export default AwardsTemplate